import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-property-status',
  templateUrl: './property-status.component.html',
  styleUrls: ['./property-status.component.scss']
})
export class PropertyStatusComponent implements OnInit {
  @Input() status: number;

  constructor() {}

  ngOnInit(): void {
  }

  getStatusLabel(status) {
    switch (status) {
      case 0:
        return 'unavailable';
      case 1:
        return 'available';
      case 2:
        return 'reserved'; // eoi
      case 3:
        return 'reserved';
      case 4:
        return 'processing'; //exchanage conditional
      case 5:
        return 'processing'; // unconditional
      case 6:
        return 'sold';
    }
  }
}
